import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import {
  ArticleDetailsComponent,
  articleDetailsResolver,
  articleSeo,
} from '../articles/article-details/article-details.component'
import { AuthorDetailsComponent } from './author-details/author-details.component'
import { AuthorsOverviewComponent } from './authors-overview/authors-overview.component'

const routes: Routes = [
  { path: '', component: AuthorsOverviewComponent },
  {
    path: ':id',
    component: AuthorDetailsComponent,
    data: { type: 'author' },
  },
  {
    path: ':id/article/:id',
    component: ArticleDetailsComponent,
    resolve: { articleDetails: articleDetailsResolver },
    data: { seo: articleSeo },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthorsRoutingModule {}
